<template>
  <div
    class="yearPicker"
    ref="yearPicker"
    :width="width"
    :model="value"
    @mouseenter="handelHover"
    @mouseleave="handelleave"
  >
    <input
      class="_inner"
      ref="inputLeft"
      v-model="startShowYear"
      @focus="onFocus"
      @blur="onBlur"
      type="text"
      name="yearInput"
      @keyup="checkStartInput($event)"
      placeholder="开始时间"
      :readonly="true"
    />
    <span style="width: 59px; text-align: center">-</span>
    <input
      class="_inner"
      ref="inputRight"
      v-model="endShowYear"
      @focus="onFocus"
      @blur="onBlur"
      type="text"
      name="yearInput"
      @keyup="checkEndInput($event)"
      placeholder="结束时间"
      :readonly="true"
    />
    <!-- <i class="dateIcon el-icon-date"></i> 按照自己标准库里面的图标设置-->
    <span class="_inner labelText"><i class="dateIcon el-icon-date"></i></span>
    <div class="_inner floatPanel" v-if="showPanel">
      <div class="_inner leftPanel">
        <div class="_inner panelHead">
          <i class="_inner el-icon-d-arrow-left" @click="onClickLeft"></i>
          {{ leftYearList[0] + "-" + leftYearList[9] + "年" }}
        </div>
        <div class="_inner panelContent">
          <div
            :class="{
              oneSelected: item === startYear && oneSelected,
              startSelected: item === startYear,
              endSelected: item === endYear,
              betweenSelected: item > startYear && item < endYear
            }"
            v-for="item in leftYearList"
            :key="item"
          >
            <a
              :class="{
                cell: true,
                _inner: true,
                selected: item === startYear || item === endYear
              }"
              @click="onClickItem(item)"
              @mouseover="onHoverItem(item)"
            >
              {{ item }}
            </a>
          </div>
        </div>
      </div>
      <div class="_inner rightPanel">
        <div class="_inner panelHead">
          <i class="_inner el-icon-d-arrow-right" @click="onClickRight"></i>
          {{ rightYearList[0] + "-" + rightYearList[9] + "年" }}
        </div>
        <div class="_inner panelContent">
          <div
            :class="{
              startSelected: item === startYear,
              endSelected: item === endYear,
              betweenSelected: item > startYear && item < endYear
            }"
            v-for="item in rightYearList"
            :key="item"
          >
            <a
              :class="{
                selected: item === startYear || item === endYear,
                betweenSelected: item > startYear && item < endYear
              }"
              @click="onClickItem(item)"
              @mouseover="onHoverItem(item)"
            >
              {{ item }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <i class="el-icon-circle-close" v-if="isMoveIn" @click="clearYear"></i>
  </div>
</template>

<script>
import moment from "moment";
const SELECT_STATE = {
  unselect: 0,
  selecting: 1,
  selected: 2
};
export default {
  name: "yearPicker",
  computed: {
    oneSelected() {
      return (
        this.curState === SELECT_STATE.selecting &&
        (this.startYear === this.endYear || this.endYear == null)
      );
    },
    startDate() {
      return this.startYear;
    },
    leftYearList() {
      return this.yearList.slice(0, 10);
    },
    rightYearList() {
      return this.yearList.slice(10, 20);
    },
    startYearFormat() {
      if (this._.isNil(this.startYear)) {
        return null;
      }
      return moment(this.startYear)
        .startOf("year")
        .format("yyyy");
    },
    endYearFormat() {
      if (this._.isNil(this.endYear)) {
        return null;
      }
      return moment(this.endYear)
        .endOf("year")
        .format("yyyy");
    }
  },
  props: {
    width: {
      default: 200
    },
    labelWidth: {
      default: 47
    },
    initYear: {
      default: null
    }
  },
  data() {
    return {
      itemBg: {},
      endShowYear: null,
      yearList: [],
      showPanel: false,
      startYear: null,
      endYear: null,
      curYear: 0,
      curSelectedYear: 0,
      startShowYear: null,
      curState: SELECT_STATE.unselect,
      value: [],
      isMoveIn: false
    };
  },
  methods: {
    checkStartInput(event) {
      if (isNaN(this.startShowYear)) {
        this.startShowYear = this.startYear;
      } else {
        this.startYear = this.startShowYear;
        this.changeYear();
      }
    },

    checkEndInput() {
      if (isNaN(this.endShowYear)) {
        this.endShowYear = this.endYear;
      } else {
        this.endYear = this.endShowYear;
        this.changeYear();
      }
    },
    changeYear() {
      if (this.startYear > this.endYear) {
        let tmp = this.endYear;
        this.endYear = this.startYear;
        this.startYear = tmp;
        this.startShowYear = this.startYear;
        this.endShowYear = this.endYear;
      }
      if (this.startYear && this.endYear) {
        this.$emit("updateTimeRange", {
          startYear: moment(this.startYear + "")
            .startOf("year")
            .valueOf(),
          endYear: moment(this.endYear + "")
            .endOf("year")
            .valueOf()
        });
      }
    },
    onHoverItem(iYear) {
      if (this.curState === SELECT_STATE.selecting) {
        let tmpStart = this.curSelectedYear;
        this.endYear = Math.max(tmpStart, iYear);
        this.startYear = Math.min(tmpStart, iYear);
      }
    },
    onClickItem(iYear) {
      if (
        this.curState === SELECT_STATE.unselect ||
        this.curState === SELECT_STATE.selected
      ) {
        this.startYear = iYear;
        this.curSelectedYear = iYear;
        this.endYear = null;
        this.curState = SELECT_STATE.selecting;
      } else if (this.curState === SELECT_STATE.selecting) {
        if (!this.endYear) {
          this.endYear = this.startYear;
          this.endShowYear = this.startYear;
          this.startShowYear = this.startYear;
          this.curState = SELECT_STATE.selected;
          this.$emit("updateTimeRange", {
            startYear: moment(this.startYear + "")
              .startOf("year")
              .valueOf()
          });
        } else {
          this.endShowYear = this.endYear;
          this.startShowYear = this.startYear;
          this.curState = SELECT_STATE.selected;
          this.$emit("updateTimeRange", {
            startYear: moment(this.startYear + "")
              .startOf("year")
              .valueOf(),
            endYear: moment(this.endYear + "")
              .endOf("year")
              .valueOf()
          });
        }
        this.value = [this.startYear, this.endYear];
        this.$emit("yearSelect", this.value);
        setTimeout(() => {
          //为动画留的时间，可优化
          this.showPanel = false;
        }, 300);
      }
    },
    onFocus() {
      this.$nextTick(() => {
        this.showPanel = true;
      });
    },
    onBlur() {
      // this.closePanel(this)
      // this.showPanel = false;
    },
    updateYearList() {
      let iStart = Math.floor(this.curYear / 10) * 10 - 10;
      iStart = iStart < 0 ? 0 : iStart;
      this.yearList = [];
      for (let index = 0; index < 20; index++) {
        this.yearList.push(iStart + index);
      }
    },
    closePanel(e) {
      if (!this.showPanel) {
        return;
      }
      if (typeof e.target.className !== "string") {
        this.$nextTick(() => {
          this.showPanel = false;
        });
        return;
      }
      // if (
      //   e.target.className.indexOf("_inner") === -1 ||
      //   (e.target.name === "yearInput" &&
      //     e.target !== this.$refs.inputLeft &&
      //     e.target !== this.$refs.inputRight)
      // ) {
      //   this.$nextTick(() => {
      //     this.showPanel = false;
      //   });
      // }

      e.stopPropagation();
      return false;
    },
    onClickLeft() {
      this.curYear = this.curYear * 1 - 10;
      this.updateYearList();
    },
    onClickRight() {
      this.curYear = this.curYear * 1 + 10;
      this.updateYearList();
    },

    //------------------对外接口------------------------
    //直接传时间戳
    setYear(startYearStamp, endYearStamp) {
      if (!isNaN(startYearStamp) && !isNaN(endYearStamp)) {
        let startYear = moment(startYearStamp).format("yyyy");
        let endYear = moment(endYearStamp).format("yyyy");
        this.startYear = startYear;
        this.endYear = endYear;
        this.endShowYear = endYear;
        this.startShowYear = startYear;
      }
    },
    // 当选择了时间且鼠标移入时
    handelHover() {
      if (this.endShowYear && this.startShowYear) {
        this.isMoveIn = true;
      }
    },
    // 鼠标移出
    handelleave() {
      if (this.endShowYear && this.startShowYear) {
        this.isMoveIn = false;
      }
    },
    // 清除时间
    clearYear() {
      this.startYear = null;
      this.endYear = null;
      this.endShowYear = null;
      this.startShowYear = null;
      this.value = [];
      this.isMoveIn = false;
      setTimeout(() => {
        this.$bus.emit("clearAllYear");
      });
    }
  },

  created() {
    this.curYear = moment().format("yyyy");
    this.updateYearList();
  },
  beforeUnmount() {
    document.removeEventListener("click", this.closePanel.bind(this));
  },

  mounted() {
    // 监听祖先组件清空搜索列表
    this.$bus.on("clearYear", () => this.clearYear());
    // 设置默认年份
    this.$bus.on("defualtYear", data => {
      console.log(data);
      this.startShowYear = data[0];
      this.endShowYear = data[1];
    });
    this.$refs.yearPicker.style = "padding-left:" + this.labelWidth + "px";
    document.addEventListener("click", this.closePanel.bind(this));
  }
};
</script>
<style lang="scss" scoped>
.yearPicker {
  font-size: 14px;
  display: flex;
  position: relative;
  width: 280px;
  height: 40px;

  .el-icon-circle-close:before {
    position: absolute;
    top: 13px;
    right: 10px;
  }

  input:first-child {
    text-align: right;
  }

  input {
    color: rgb(96, 98, 102) !important;
  }

  .labelText {
    font-size: 12px;
    position: absolute;
    left: 23px;
  }

  background-color: #fff;

  span:nth-child(1) {
    width: 80px;
    text-align: center;
  }

  span {
    padding: 0 8px;
    height: 40px;
    line-height: 40px;
  }

  border: 1px solid rgb(220, 223, 230);
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  padding: 0 28px 0 8px;
  box-sizing: border-box;

  .floatPanel {
    > div {
      width: 50%;
    }

    padding: 0 16px;
    position: absolute;
    display: flex;
    background-color: #fff;
    z-index: 2000;
    border-radius: 4px;
    width: 650px;
    height: 250px;
    top: 40px;
    left: -23px;
    border: 1px solid rgb(223, 228, 237);
    box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 12px 0px;

    .panelContent {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
      height: calc(100% - 70px);

      .oneSelected {
        border-top-right-radius: 24px;
        border-bottom-right-radius: 24px;
      }

      .startSelected {
        background-color: #f6f6f7;
        border-top-left-radius: 24px;
        border-bottom-left-radius: 24px;
      }

      .endSelected {
        background-color: #f6f6f7;
        border-top-right-radius: 24px;
        border-bottom-right-radius: 24px;
      }

      .betweenSelected {
        background-color: #f6f6f7;
      }

      > div {
        width: 75px;
        height: 48px;
        line-height: 48px;
        margin: 3px 0;
        // border-radius: 24px;
        text-align: center;

        a {
          display: inline-block;
          width: 60px;
          height: 36px;
          cursor: pointer;
          line-height: 36px;
          border-radius: 18px;

          &:hover {
            background-color: rgb(24, 144, 255);
            color: #fff;
          }

          .startSelected {
            background-color: rgb(24, 144, 255);
            border-top-left-radius: 24px;
            border-bottom-left-radius: 24px;
            color: #fff;
          }

          .endSelected {
            background-color: rgb(24, 144, 255);
            border-top-right-radius: 24px;
            border-bottom-right-radius: 24px;
            color: #fff;
          }
        }

        .selected {
          background-color: rgb(24, 144, 255);
          color: #fff;
        }
      }
    }

    .panelHead {
      position: relative;
      height: 46px;
      line-height: 46px;
      text-align: center;
      font-size: 16px;

      i {
        position: absolute;
        cursor: pointer;
        top: 17px;

        &:hover {
          color: rgb(24, 144, 255);
        }
      }
    }

    .rightPanel {
      padding-left: 8px;
    }

    .leftPanel .panelHead i {
      left: 20px;
    }

    .rightPanel .panelHead i {
      right: 20px;
    }
  }

  .floatPanel::before {
    content: "";
    height: 100%;
    position: absolute;
    left: 50%;
    width: 1px;
    border-left: 1px solid #e4e4e4;
  }
}

input {
  width: 60px;
  border: none;
  height: 38px;
  line-height: 38px;
  box-sizing: border-box;
  background-color: transparent;
}

input:focus {
  outline: none;
  background-color: transparent;
}

.yearPicker:hover {
  border-color: #c0c4cc;
}

.dateIcon {
  position: absolute;
  right: 15px;
  top: 12px;
  color: #adb2bc;

  &::before {
    font-size: 14px;
  }
}

.yearPicker input::-webkit-input-placeholder {
  color: #adb2bc !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/yearrange.vue